import(/* webpackMode: "eager" */ "/app/src/app/gdpr-subprocessors/page.tsx");
